import { Pipe } from '@angular/core';
import { isNumber } from '../helpers/helpers';
var IsNumberPipe = (function () {
    function IsNumberPipe() {
    }
    IsNumberPipe.prototype.transform = function (input) {
        return isNumber(input);
    };
    IsNumberPipe.decorators = [
        { type: Pipe, args: [{ name: 'isNumber' },] },
    ];
    /** @nocollapse */
    IsNumberPipe.ctorParameters = function () { return []; };
    return IsNumberPipe;
}());
export { IsNumberPipe };
//# sourceMappingURL=is-number.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-number.js
// module id = 252
// module chunks = 4